export const FullLoader = 'FullLoader';
